<div *ngIf="passedData.progress$ | async as progress">
  {{progress.text}}
  <br>
  <div *ngIf="progress.action !== adapterFileHandlerActionEnum.READY_TO_DOWNLOAD">
    <mat-progress-bar mode="determinate" [value]="progress.current / progress.total * 100"></mat-progress-bar>
  </div>
  <button mat-button (click)="closeDialog()">Close</button>
</div>
